import { Component, Input, ChangeDetectionStrategy, Injector, TemplateRef, QueryList, ContentChildren } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * タイトル
 *【内容:content:string】
 *【表示条件:visible:boolean】
 *【スモールサイズ:smallSize:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-title',
  templateUrl: './title.html',
  styles: [`
    
  `]
})
export class Title extends BaseWidget {
  /**
   * 子要素
   */
  children:TemplateRef<any>[]

  @ContentChildren(TemplateRef) templateRefs:QueryList<TemplateRef<any>>

  ngAfterContentInit() {
    this.children = this.templateRefs.toArray()
  }
  /**
   * 内容
   */
  @Input() content:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * スモールサイズ
   */
  @Input() smallSize:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/title/title.component.ts